<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-sm-6 offset-sm-3 col-12">
        <h3>{{$t('message.menu.service_requests')}}</h3>
        <section>
          <template v-for="serviceRequest, index in serviceRequests">
            <router-link class="no-style" :to="'/service-requests/' + serviceRequest.id">
              <div class="card shadow-sm">
                <div class="card-body">
                  <div class="text-remark">
                    {{ $t('message.service_request.request') }} #{{ serviceRequest.id }}
                  </div>
                  <div class="mt-2">
                    <label for="">{{ serviceRequest.service | multiLangName }}</label>
                  </div>
                  <div class="text-remark" v-if="serviceRequest.service_date">
                    <i class="fal fa-clock"></i>
                    {{ serviceRequest.service_date | prettyDate }}
                  </div>
                  <div class="text-right mt-2 -status-new">
                    {{ serviceRequest.service_request_status | multiLangName }}
                  </div>
                </div>
              </div>
            </router-link>
          </template>
        </section>
      </div>
      <div class="col-sm-6 offset-sm-3 col-12" v-if="isMore">
        <button class="btn btn-success btn-block"
                :disabled="isFetching"
                @click="loadMore">
          {{ isFetching ? $t('message.button.loading') : $t('message.button.load_more') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'Index',
    data () {
      return {
        queryData: {
          page: 0,
          limit: 10,
          user_id: null
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('serviceRequest', ['serviceRequests', 'isFetching', 'isMore'])
    },
    methods: {
      loadMore () {
        this.queryData.page++
        this.$store.dispatch('serviceRequest/LOAD_SERVICE_REQUESTS', this.queryData)
      }
    },
    mounted () {
      if (this.user) {
        this.queryData.user_id = this.user.id
        this.$store.commit('serviceRequest/SET_SERVICE_REQUESTS', [])
        this.$store.dispatch('serviceRequest/LOAD_SERVICE_REQUESTS', this.queryData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/serviceRequest/Index.vue